import { AxiosPromise, CancelToken } from 'axios';
import {
    CalendarEvent,
    CreateCalendarEventRequest,
    RetrieveCalendarEventsByRange,
    UpdateCalendarEventRequest,
} from '../sic-lib/types/CalendarEvent';
import { apiInstance as instance } from './';

export function createCalendarEvent(
    data: CreateCalendarEventRequest,
    //cancelToken: CancelToken
): AxiosPromise<CalendarEvent> {
    return instance.post('/CalendarEvents', data, {
        //cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function updateCalendarEvent(
    eventId: number,
    data: UpdateCalendarEventRequest,
    //cancelToken: CancelToken
): AxiosPromise<CalendarEvent<string>> {
    return instance.post(`/CalendarEvents/${eventId}`, data, {
        //cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function deleteCalendarEvent(
    eventId: number,
    //cancelToken: CancelToken
): AxiosPromise<unknown> {
    return instance.delete(`/CalendarEvents/${eventId}`, {
        //cancelToken: cancelToken,
    });
}

export function updateCalendarEventOutcome(
    eventId: number,
    outcome: string,
    //cancelToken: CancelToken
): AxiosPromise<CalendarEvent<string>> {
    return instance.post(`/CalendarEvents/${eventId}/Outcome?outcome=${outcome}`, null, {
        //cancelToken: cancelToken,
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function requestContactCalendarEvents(
    contactId: number,
    cancelToken: CancelToken,
): AxiosPromise<CalendarEvent<string>[]> {
    return instance.get(`/Contacts/${contactId}/CalendarEvents`, {
        cancelToken: cancelToken,
    });
}

export function requestCalendarEventsByRange(
    data: RetrieveCalendarEventsByRange,
    cancelToken: CancelToken,
): AxiosPromise<CalendarEvent<string>[]> {
    return instance.post(`/CalendarEvents/GetByRange`, data, {
        cancelToken: cancelToken,
    });
}
